import React from 'react';
import PropTypes from 'prop-types';
import { LoadingPage, LoadingButton } from './styles';

export default function Loading({ buttonLoading }) {
  return buttonLoading ? (
    <LoadingButton style={{ height: '16px', width: '16px' }} thickness={5} />
  ) : (
    <LoadingPage />
  );
}

Loading.propTypes = {
  buttonLoading: PropTypes.bool,
};

Loading.defaultProps = {
  buttonLoading: false,
};
